import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface NoReportAccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onGoBack: () => void;
  onReturnToDashboard: () => void;
}

/**
 * No Report Access Modal - shown when user skips both Match Report AND EDD.
 * Explains that a purchase is required to view the report and offers options.
 */
export function NoReportAccessModal({
  open,
  onOpenChange,
  onGoBack,
  onReturnToDashboard,
}: NoReportAccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[420px]" hideCloseButton>
        <DialogHeader className="text-center sm:text-center">
          <div className="mx-auto mb-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
              <Lock className="h-8 w-8 text-gray-500" />
            </div>
          </div>
          <DialogTitle className="text-[20px] font-semibold text-[#051923]">
            Report Not Available
          </DialogTitle>
          <DialogDescription className="pt-3 text-[15px] leading-relaxed text-[#051923]">
            To view the full screening report with detailed findings, evidence, and risk analysis, a
            report purchase is required.
            <br />
            <br />
            Your screening data has been saved and will be available when you're ready to purchase.
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6 flex flex-col gap-3">
          <Button
            onClick={onGoBack}
            className="h-[45px] w-full rounded-[5px] bg-[#131313] text-[18px] font-medium leading-none tracking-normal text-white hover:bg-[#131313]/90"
          >
            Purchase Report
          </Button>
          <Button
            variant="outline"
            onClick={onReturnToDashboard}
            className="h-[45px] w-full rounded-[5px] border-[1.5px] border-[#131313] bg-white text-[18px] font-medium leading-none tracking-normal text-[#131313] hover:bg-gray-50"
          >
            Return to Dashboard
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
